<template> 
    <div style="background:#fff; margin-top:1px;margin-left:1px;overflow-y:auto; "> 
        <!--编辑框-->
        <div style="display:flex;line-height:35px;height:45px">
            <div style="font-size:12px;width:100px">单据编号</div>
            <el-input   type="text"   v-model="t_idno" style="width:420px"></el-input>              
        </div>
        <div style="display:flex;line-height:35px;height:45px;margin-top:15px">
            <div style="font-size:12px;width:100px">报表清单</div>
            <el-select v-model="v_repno"   style="width:420px">
                <el-option v-for="(item,index) in t_replist" :key="index" :label="item.REPNM" :value="item.REPURL" ></el-option>
            </el-select>            
        </div>
        <div style="display:flex;line-height:35px;height:45px;margin-top:15px">
            <div style="font-size:12px;width:100px">账套ID</div>
            <el-input disabled  type="text"   v-model="v_corpid" style="width:420px"></el-input>              
        </div>
        <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px;;margin-top:15px  ">
            <span style="float:right">

                <el-button type="info" size="mini" icon="iconfont icon-shanchu" @click="btnExit" style=" margin-left:30px;">取消</el-button>
                <el-button type="primary" size="mini" icon="iconfont icon-gaojichazhao2" @click="cfmOk" style=" margin-left:30px;">预览</el-button>
            </span>
        </div>
 
    </div>
</template>
<script>
 
export default {
    props: {
        v_idno:{
            type: String,
        },
        v_corpid:{
            type: String,
        },
        v_replist:{
            type:Array,
        } 
    },
    name: 'rep_preview',
    data () {
        return {
            editWin:false,
            v_repno:'',
            t_idno:'',
            t_replist:[],
        }
    },
    created () {
        
    },
    components: {
 
    },
    mounted () {  
       this.t_idno =this.v_idno
       this.t_replist =JSON.parse(JSON.stringify(this.v_replist))
       if (this.v_replist.length>0){
           this.v_repno =this.v_replist[0]['REPURL']
       }
    } ,
    watch: {
        v_idno:function(){
            this.t_idno =this.v_idno
        },
        v_replist:function(){
            this.t_replist =JSON.parse(JSON.stringify(this.v_replist))
            if (this.v_replist.length>0){
                this.v_repno =this.v_replist[0]['REPURL']
            }
        }
    },
    methods: {  
        btnExit(){
            this.$emit('child-exit' )
        },
        //
        cfmOk(){
            this.$emit('child-sure',{IDNO:this.t_idno ,CORPID:this.v_corpid,REPNO:this.v_repno})
        },
    }
}
 
</script>
<style scoped lang="less" >
    .selinput{
        width:340px;
        margin-left:10px; 
    }
    .colwidth{
        width:140px;
    }
    .colwidth2{
        width:642px;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    } 
    .item-width  {
        width: 48%;
        color:#409EFF;
    }
    .item-width2  {
        width: 97%;
    } 
</style>
<style lang="less">
    .el-table__body {
        width: 100%;
        // 使表格兼容safari，不错位
        table-layout: fixed !important;
    }
   .el-table {
    th {
        padding: 0 ;
    }
    thead{
        height: 15px !important;
        color:rgb(128,128, 128);
        font-size:12px;
    }
    td {
        padding: 5px ;
        font-size:11px;
    }   
  }
  .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
